import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import * as paymentsService from '../../services/paymentsService';
import paymentActionConstants from '../constants/paymentActionConstants';

export const getPayments = (page, perPage, searchTerm, payoutPageFilter) => async (dispatch) => {
  dispatch({ type: paymentActionConstants.GET_PAYMENTS });

  const response = await paymentsService.getPayments(page, perPage, searchTerm, payoutPageFilter);
  if (response.data.response_code === responseCodes.OK) {
    dispatch({ type: paymentActionConstants.GET_PAYMENTS_SUCCESS, payload: response.data.payload });
  } else {
    dispatch({ type: paymentActionConstants.GET_PAYMENTS_ERROR });
    Notification.error(response.data.error);
  }
};
